/**
 * @internalapi
 */
export class PostMessagePairingResponse {
    type = 'postmessage-pairing-response';
    id;
    name;
    icon;
    appUrl;
    publicKey;
    version;
    constructor(id, name, publicKey, version, icon, appUrl) {
        this.id = id;
        this.name = name;
        this.icon = icon;
        this.appUrl = appUrl;
        this.publicKey = publicKey;
        this.version = version;
    }
}
/**
 * @internalapi
 */
export class ExtendedPostMessagePairingResponse extends PostMessagePairingResponse {
    senderId;
    extensionId;
    constructor(id, name, publicKey, version, senderId, extensionId, icon, appUrl) {
        super(id, name, publicKey, version, icon, appUrl);
        this.senderId = senderId;
        this.extensionId = extensionId;
    }
}
// TODO: Rename to "WalletPeerInfo"?
//# sourceMappingURL=PostMessagePairingResponse.js.map